import angular from 'angular'

angular.module('eficienciaFiscalModule').component('efPermissaoFerramenta', {
    bindings: {
        disabled: '<',
        message: '@'
    },
    transclude: true,
    template: `
    <div style="position: relative">
        <div ng-if="$ctrl.disabled" class="ef-permissao-ferramenta-overlay">
            <highlighted>
                <main>{{ $ctrl.message || 'Você não possui acesso a uma filial que tenha essa ferramenta contratada.' }}</main>
                <secondary>
                    <a href="javascript:Intercom('show')">Clique aqui</a> e fale com um de nossos consultores.
                </secondary>
            </highlighted>
        </div>
        <div ng-class="{'ef-permissao-ferramenta-blurred': $ctrl.disabled}">
            <ng-transclude></ng-transclude>
        </div>
    </div>
    `
})
